import React from 'react';
import DatePicker from 'react-datepicker';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { isSameWeek, addWeeks } from 'date-fns';
import cx from 'classnames';
import WeeklyDatePickerInput from './WeeklyDatePickerInput';
import DatePickerArrowWrapper from '@shared/components/DatePickerArrowWrapper';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';

/**
 * @typedef {object} WeeklyDatePickerProps
 * @property {boolean} [loading]
 * @property {Date} [selectedDate]
 * @property {(newDate: Date) => void} setSelectedDate
 * @property {boolean} [isLeftArrowDisabled]
 * @property {Date} [minDate]
 */

/**
 * @param {WeeklyDatePickerProps} props
 */
const WeeklyDatePicker = props => {
  const {
    loading = false,
    selectedDate,
    setSelectedDate,
    isLeftArrowDisabled = false,
    minDate
  } = props;

  const handleLeftArrowClick = () => {
    const newDate = addWeeks(selectedDate, -1);
    setSelectedDate(newDate);
  };

  const handleRightArrowClick = () => {
    const newDate = addWeeks(selectedDate, +1);
    setSelectedDate(newDate);
  };

  const highlightWeekDays = date => {
    return cx({
      'react-datepicker__day--selected': isSameWeek(date, selectedDate)
    });
  };

  const handleWeekSelect = date => {
    setSelectedDate(date);
  };

  return (
    <SkeletonWrapper show={loading}>
      <DatePickerArrowWrapper
        handleLeftArrowClick={handleLeftArrowClick}
        handleRightArrowClick={handleRightArrowClick}
        isLeftArrowDisabled={isLeftArrowDisabled}>
        <div>
          <div className='date-picker-wrapper'>
            <div className='custom-date-picker-input'>
              <DatePicker
                className='date-picker'
                selected={selectedDate}
                onChange={date => handleWeekSelect(date)}
                minDate={minDate}
                startDate={selectedDate}
                dayClassName={highlightWeekDays}
                inline={false}
                customInput={<WeeklyDatePickerInput selectedDate={selectedDate} />}
              />
            </div>
            <CalendarTodayIcon />
          </div>
        </div>
      </DatePickerArrowWrapper>
    </SkeletonWrapper>
  );
};

export default WeeklyDatePicker;
